module.exports = __webpack_public_path__ + "static/media/dark-submenu-usuarios.72a4a720.svg";